import { render } from "./CampaignsEditor.vue?vue&type=template&id=00823b50"
import script from "./CampaignsEditor.vue?vue&type=script&lang=js"
export * from "./CampaignsEditor.vue?vue&type=script&lang=js"

import "./CampaignsEditor.vue?vue&type=style&index=0&id=00823b50&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__